import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { PROFILE_MAX_VISIBLE_CERTIFICATIONS_SHORT_DESKTOP } from '@utils/constants';
import React from 'react';
import MoreItemsButton from '../MoreItemsButton';
import CompactCertification from './CertificationDisplay/CompactCertification';
import s from './Certifications.module.scss';

const renderCompactCertification = (cert: PublicCertification) => (
  <CompactCertification key={cert.certificationType} cert={cert} />
);

interface CompactCertificationsProps {
  certifications: PublicCertification[];
  isMobileView?: boolean;
}

const CompactCertifications: React.FC<CompactCertificationsProps> = ({
  certifications,
  isMobileView,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Text size="small" weight="thin">
        {t('profile-page-certifications-title')}
      </Text>
      <Box>
        <div className={s.shortDesktop}>
          <MoreItemsButton
            items={certifications}
            maxVisibleItems={PROFILE_MAX_VISIBLE_CERTIFICATIONS_SHORT_DESKTOP}
            isMobileView={isMobileView}
            renderItem={renderCompactCertification}
          />
        </div>

        <div className={s.regularHeightDesktop}>
          {certifications.map(renderCompactCertification)}
        </div>
      </Box>
    </>
  );
};

export default CompactCertifications;
